const meters = {
  meters: {
    engineHours: {
      title: 'x-label:workflow4.meters.engine hours.engine hours',
      data: [
        { label: 'x-label:workflow4.meters.engine hours.hrs total', num: '0286.8' },
        { label: 'x-label:workflow4.meters.engine hours.hrs trip', invert: true, num: '0286.8' }
      ],
      resetText: [
        'x-label:workflow4.meters.engine hours.reset engine trip hours',
        'x-label:workflow4.meters.engine hours.are you sure?'
      ],
      routes: {
        left: 'meters/exit',
        right: 'meters/pto-hours'
      }
    },
    ptoHours: {
      title: 'x-label:workflow4.meters.pto hours.pto hours',
      data: [
        { label: 'x-label:workflow4.meters.pto hours.hrs total', num: '0232.6' },
        { label: 'x-label:workflow4.meters.pto hours.hrs trip', invert: true, num: '0232.6' }
      ],
      resetText: [
        'x-label:workflow4.meters.pto hours.reset pto trip hours',
        'x-label:workflow4.meters.pto hours.are you sure?'
      ],
      routes: {
        left: 'meters/engine-hours',
        right: 'meters/trip-statistics'
      }
    },
    tripStatistics0: {
      title: 'x-label:workflow4.meters.trip statistics.trip statistics',
      data: [
        { label: 'x-label:workflow4.meters.trip statistics.view trip statistics' },
      ],
      routes: {
        left: 'meters/pto-hours',
        center: 'meters/trip-statistics/1',
        right: 'meters/exit'
      },
    },
    tripStatistics1: {
      title: 'x-label:workflow4.meters.trip statistics.trip statistics 1',
      data: [
        { label: 'x-label:workflow4.meters.trip statistics.trip statistics 1.engine hours', invert: true, num: '0.00' },
        { label: 'x-label:workflow4.meters.trip statistics.trip statistics 1.pto hours', invert: true, num: '0.00' }
      ],
      routes: {
        center: 'meters/trip-statistics/2',
      }
    },
    tripStatistics2: {
      title: 'x-label:workflow4.meters.trip statistics.trip statistics 2',
      data: [
        { label: 'x-label:workflow4.meters.trip statistics.trip statistics 2.engine hours', invert: true, num: '0.00' },
        { label: 'x-label:workflow4.meters.trip statistics.trip statistics 2.pto hours', invert: true, num: '0.00' }
      ],
      routes: {
        center: 'meters/trip-statistics/3',
      }
    },
    tripStatistics3: {
      title: 'x-label:workflow4.meters.trip statistics.trip statistics 3',
      data: [
        { label: 'x-label:workflow4.meters.trip statistics.trip statistics 3.engine hours', invert: true, num: '0.00' },
        { label: 'x-label:workflow4.meters.trip statistics.trip statistics 3.pto hours', invert: true, num: '0.00' }
      ],
      routes: {
        center: 'meters/trip-statistics/4',
      }
    },
    tripStatistics4: {
      title: 'x-label:workflow4.meters.trip statistics.trip statistics 4',
      data: [
        { label: 'x-label:workflow4.meters.trip statistics.trip statistics 4.engine hours', num: '286.8' },
        { label: 'x-label:workflow4.meters.trip statistics.trip statistics 4.pto hours', num: '232.6' }
      ],
      routes: {
        center: 'meters/trip-statistics/5',
      }
    },
    tripStatistics5: {
      title: 'x-label:workflow4.meters.trip statistics.trip statistics 5',
      data: [
        { label: 'x-label:workflow4.meters.trip statistics.trip statistics 5.engine hours', invert: true, num: '0.00' },
        { label: 'x-label:workflow4.meters.trip statistics.trip statistics 5.pto hours', invert: true, num: '0.00' }
      ],
      routes: {
        center: 'meters/trip-statistics',
      }
    },
    exit: {
      title: 'x-label:workflow4.meters.exit.exit',
      routes: {
        left: 'meters/trip-statistics',
        right: 'meters/engine-hours'
      }
    }
  }
};

export default meters;



// WEBPACK FOOTER //
// ./src/screens/data/flow4/meters.js